export default {
  BusinessStockDeliveryInform: {
    header: {
      queryCode: 'Order No.',
      status: 'Outbound Status',
      outLogicWarehouseCode: 'Outbound Logical Warehouse',
      outLogicWarehouseCodeText: 'Please enter the logic warehouse code',
    },

    table: {
      code: 'Outbound notice Order No.',
      platformOrderCode: 'Customer Order No.',
      orderCode: 'CSG Order No.',
      frontRecordCode: 'Front Tracking Number',
      outTypeMeaning: 'Outbound Type',
      status: 'Outbound Status',
      qty: 'Quantity to be shipped',
      outLogicWarehouseCode: 'Outbound logic warehouse code',
      outLogicWarehouseName: 'Outbound logic warehouse name',
      shopName: 'Store',
      channelTypeCodeMeaning: 'Sales Channel',
    },

    msgError: 'Please select the operation for the pending outgoing documents',
    ship: 'Ship',
  }
};
